
export function normalizeItalianFiscalCode(code: string) {
    return code.replace(/\s/g, "").toUpperCase()
}

function validate_temporary(code: string) {
    if (! /^[0-9]{11}$/.test(code))
        return false
    var s = 0;
    for (var i = 0; i < 11; i++) {
        var n = code.charCodeAt(i) - "0".charCodeAt(0);
        if ((i & 1) === 1) {
            n *= 2;
            if (n > 9)
                n -= 9;
        }
        s += n;
    }
    if (s % 10 !== 0)
        return false
    return true
}

function validate_regular(code: string) {
    if (! /^[0-9A-Z]{16}$/.test(code))
        return false
    var s = 0;
    var even_map = "BAFHJNPRTVCESULDGIMOQKWZYX";
    for (var i = 0; i < 15; i++) {
        var c = code[i];
        var n = 0;
        if ("0" <= c && c <= "9")
            n = c.charCodeAt(0) - "0".charCodeAt(0);
        else
            n = c.charCodeAt(0) - "A".charCodeAt(0);
        if ((i & 1) === 0)
            n = even_map.charCodeAt(n) - "A".charCodeAt(0);
        s += n;
    }
    if (s % 26 + "A".charCodeAt(0) !== code.charCodeAt(15))
        return false
    return true
}

export function validateItalianFiscalCode(code: string) {
    code = normalizeItalianFiscalCode(code)
    if (code.length === 0)
        return false
    else if (code.length === 16)
        return validate_regular(code)
    else if (code.length === 11)
        return validate_temporary(code)
    else
        return false
}